import { StyleSheet } from "react-native"

export default StyleSheet.create({
  jobStatus: {
    justifyContent: "center",
    flex: 1,
  },
})
